import React, { useState } from 'react'
import clsx from 'clsx'

import Heading from '../../components/Heading/Heading'
import Button from '../../components/Button/Button'

import bgDesktopImage from '../../images/subscribe-desktop.png'
import bgMobileImage from '../../images/subscribe-mobile.png'

export const SubcribeForm = ({ otherClasses }) => {
  const subcribeFormClasses = clsx(
    otherClasses,
    'w-full max-w-[1200px] mx-auto relative rounded-[15px] py-10 px-6 lg:px-[280px]'
  )

  const [userEmail, setUserEmail] = useState('')
  function encode(data) {
    const formData = new FormData()
    for (const key of Object.keys(data)) {
      formData.append(key, data[key])
    }
    return formData
  }

  async function handleSubmit(e) {
    e.preventDefault()
    const form = e.target
    try {
      await fetch('/', {
        method: 'POST',
        body: encode({
          'form-name': form.getAttribute('name'),
          email: userEmail,
        }),
      })
      setUserEmail('')
      form.reset()
    } catch (error) {
      alert(error)
    }
  }

  return (
    <div className={subcribeFormClasses} data-testid="subcribe-form">
      <img
        src={bgDesktopImage}
        alt="bg-desktop"
        className="absolute top-0 left-0 bottom-0 w-full h-full -z-10 hidden lg:block"
      />
      <img
        src={bgMobileImage}
        alt="bg-desktop"
        className="absolute top-0 left-0 bottom-0 w-full h-full -z-10 lg:hidden"
      />
      <div className="flex flex-col items-center">
        <Heading
          type="h4"
          otherClasses="font-Manrope font-light text-white text-2xl leading-[34px] lg:text-[27px] lg:leading-[34px] mb-6 text-center"
        >
          Never Miss an Update
        </Heading>
        <p className="font-Work_Sans font-normal text-sm leading-4 lg:text-base lg:leading-6 text-neutral-100 text-center mb-12">
          Subscribe to our consumer protection blog to stay up to date on
          current news, law changes, and red flags to watch out for.
        </p>
        <form
          name="newsletter-subscription"
          method="post"
          action=""
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={handleSubmit}
          className="flex flex-col lg:flex-row items-start lg:w-auto w-full lg:items-center gap-6 lg:gap-2"
        >
          <input
            type="email"
            name="email"
            id="email"
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            required
            placeholder="Enter your email address"
            className="rounded-[30px] bg-white py-3 px-6 placeholder:text-gray-300 font-normal text-base leading-6 outline-0 w-full lg:w-[398px] font-Work_Sans "
          />
          <Button variant="primary" label="Subscribe" />
        </form>
      </div>
    </div>
  )
}

export default SubcribeForm
